export default {
  hello: {
    title: '欢迎来到你的vue.js app',
    languageBtn: '切换语言',
    themeBtn: '切换主题'
  },
  nav: {
    title: '我的控制台',
    home: '主页',
    components: '组件',
    example: '实例',
    noAccess: '无权限',
    user: '用户'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js